import axios from 'axios'
import store from '@/store'
import QS from 'qs'
import {Toast} from "vant";
import router from "@/router";
import {debounce} from "lodash-es";
import {baseURL,locationTo} from "@/utils/url";

/**
 * 定义请求常量
 * TIME_OUT, BASE_URL
 */
export const timeout = 10000;    // 请求超时时间

// 创建axios实例
const instance = axios.create({
  baseURL,
  timeout
});
let referer = null;
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 企业微信/小程序自动登录用
instance.defaults.headers.common['htReferer'] = location.href;
// 封装请求拦截
instance.interceptors.request.use(
  config => {
    config.headers['last-referer'] = window.location.href.split('#')[0]
    return config
  },
  error => {
    console.warn(error);
    return Promise.reject(error)
  }
);

// 封装响应拦截
instance.interceptors.response.use(
  response => {
    let resp = response.data;
    return Promise.resolve(resp)
  },
  error => {
    let errorResp = error.response;
    if (errorResp.status === 1001 || errorResp.status === 4001) {
      Toast("登录过期，请关闭后重新打开");
        Toast.loading({message: '跳转登录中...', forbidClick: true,})
        router.replace("/login");
    }

    if(errorResp.status === 1002 || errorResp.status === 4002){
      router.push('/empty/forbidden/您没有权限访问当前页面或执行此操作');
    }

    if(errorResp.status === 406){
      router.push('/empty/internal/提交内容包含了xss敏感信息，请检查确认后重试');
    }

    if (errorResp.status === 500) {
      store.commit('setErrorShow', true);
    }
    if(errorResp.status === 302){
        if(errorResp.headers.authurl){
          let targetUrl = errorResp.headers.authurl;
          locationTo(targetUrl);
        }
        else{
          router.replace('/home');
        }
    }
    if (errorResp.message === 'Network Error') {
      router.push('/empty/network');
    }
    return Promise.reject(errorResp);
  }
);
class http {
  static async request(url, method, params) {
    return await instance.request({
      url: url,
      method: method,
      params: params
    })
  }

  static async get(url, params) {
    return await instance.get(url, {params: params})
  }

  static async post(url, params) {
    return await instance.post(url, QS.stringify(params))
  }
}

export default http
